angular.module("registrace")

.controller('RegistraceEmailSentCtrl', ["$scope", "$location", "$http", "api", "Container", "$window", "Registrace", function($scope, $location, $http, api, Container, $window, Registrace) {
	

    $scope.deaktivateApp = deaktivateApp;

    if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
        api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
        return;
    }

    $scope.target = Container.getTarget();
	
	
}]);